import { UserRightsMessages, TranslationUserRightsMessages } from "../interfaces/userRightsMessages";

export const messages: TranslationUserRightsMessages = {
  [UserRightsMessages.launcher]: "Início",
  [UserRightsMessages.rightsControl]: "Controle de direitos",
  [UserRightsMessages.selectTenant]: "Selecionar tenant",
  [UserRightsMessages.userControl]: "Controle de usuário",
  [UserRightsMessages.roleDashboardTabCaption]: "Grupos",
  [UserRightsMessages.roleDashboardPageTitle]: "Controle de direitos de usuários",
  [UserRightsMessages.createRoleTabCaption]: "Criar grupo",
  [UserRightsMessages.editRoleTabCaption]: "Editar grupo",
  [UserRightsMessages.createUserTabCaption]: "Criar usuário",
  [UserRightsMessages.editUserTabCaption]: "Editar usuário",
  [UserRightsMessages.usersWithoutRole]: "Usuários sem grupo",
  [UserRightsMessages.noRoleOrUserRegistered]: "Nenhum grupo ou usuário cadastrado",
  [UserRightsMessages.noSuiteAllowed]: "Você não tem acesso ao controle de direito de usuários da suite Topcon",
  [UserRightsMessages.memberCount]: "{{count}} membros",
  [UserRightsMessages.userCount]: "{{count}} usuários"
};